export default __webpack_public_path__ + "static/media/HomeComputerCropped.b54e518c.jpg";